import React, { useContext, useEffect, useState, useCallback } from 'react';
import { CsrfTokenContext } from '../CsrfTokenContext';
import Select from 'react-select';
import './StrategyRuleSettings.css';
import { useDispatch, useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import DecisionModal from './DecisionModal';
import { setLastConditionalSelectionBuy, setBuyStrategy, setIsExpressionBuyCorrect, setBuyConditions, setBuySelectedItems, setBuyExpressionValidation, setCanDelete, setSelectedStrategy, setEditMode, setSelectedRowIndex, setErrorMsg } from '../pages/slices/buyStrategySettingsSlicer';
import { setLastConditionalSelectionSell, setSellStrategy, setIsExpressionSellCorrect, setSellConditions, setSellSelectedItems, setSellExpressionValidation } from '../pages/slices/sellStrategySettingsSlicer';
import { setDateRangeChanged } from '../pages/slices/simulationEntriesSlicer';
import 'bootstrap-icons/font/bootstrap-icons.css';
import BecomePremiumInvite from './BecomePremiumInvite'; 
import LimitedAdvise from './LimitedAdvise'; 
import TextBaloon from './TextBaloon'; 
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';

const StrategyRuleSettings = ({ title }) => {
    const dispatch = useDispatch();   

    const { lastConditionalSelectionBuy, buyStrategy, isExpressionBuyCorrect, buyConditions, buySelectedItems, buyExpressionValidation, canDelete, selectedStrategy, editMode, selectedRowIndex, errorMsg }  = useSelector(state => state.buyStrategySettings);
    const { lastConditionalSelectionSell, sellStrategy, isExpressionSellCorrect, sellConditions, sellSelectedItems, sellExpressionValidation }  = useSelector(state => state.sellStrategySettings);
    const { walletId, isPremium } = useSelector(state => state.globalData);

    const [strategies, setStrategies] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [actionStatus, setActionStatus] = useState(false);        
    const [spin, setSpin] = useState(false);        
    const [justSaved, setJustSaved] = useState(false);
    const [blink, setBlink] = useState(false);
    const [noPremium, setNoPremium] = useState(false);
    const [notification, setNotification] = useState('');
    const [note, setNote] = useState('');
    
        
    const csrfToken = useContext(CsrfTokenContext);
    
    const handleShow = () => setModalShow(true);
    const handleClose = () => setModalShow(false);

    const saveStrategies = (isDuplicate = false) =>{

        if(walletId===0){
            dispatch(setErrorMsg('Wallet not connected! Please connect your wallet to continue. If this is your first connection, you’ll receive a 1-day trial.'));
            return;
        }

        if(!isPremium){
            setNoPremium(true);
            return;
        }
                
        if(!editMode || isDuplicate){         
            set_strategy(walletId, buyStrategy, sellStrategy, note);
        }
        else{            
            upd_strategy(walletId, buyStrategy, sellStrategy, selectedStrategy, note);
        }

        dispatch(setDateRangeChanged(true));
        
        resetStrategies();
    }

    const deleteStrategy = () =>{
        
        if(!isPremium){
            setNoPremium(true);
            return;
        }

        del_strategy(walletId, selectedStrategy);
        dispatch(setDateRangeChanged(true));
    }  

    function isNumeric(value) {
        const result = /^-?\d+(\.\d+)?$/.test(value);        
        return result;
    }
    
    const handleSelection = (strg, index) => {
        dispatch(setSelectedStrategy(strg.strgId));
        dispatch(setEditMode(true));
        dispatch(setSelectedRowIndex(index));
        setNote(strg.note);
        const selBuyParts = strg.buy.split(' ');
        const selSellParts = strg.sell.split(' ');
    
        const maxBuy = Math.floor(selBuyParts.length / 4);
        const maxSell = Math.floor(selSellParts.length / 4);
    
        let buyConditions = [];
        for (let index = 0; index < maxBuy; index++) {
            const operand2Value = isNumeric(selBuyParts[index * 4 + 2]) ? Number(selBuyParts[index * 4 + 2]) : selBuyParts[index * 4 + 2];
            const condition = {
                operand1: {value : selBuyParts[index * 4] || ''},
                operator: {value : selBuyParts[index * 4 + 1] || ''},
                operand2: {value : operand2Value, inputValue : operand2Value},
                conditional: {value : selBuyParts[index * 4 + 3] === '$' ? 'None' : selBuyParts[index * 4 + 3]},
                operand2Options: getOperand2Options(isNumeric(selBuyParts[index * 4]) ? Number(selBuyParts[index * 4]) : selBuyParts[index * 4]),                
                enabled: {value : true},
                operatorEnabled: {value : true},
                operand2Enabled: {value : true},
                conditionalEnabled: {value : true},
                fromDb: {value : true}
            };
            buyConditions.push(condition);
        }        
    
        let sellConditions = [];
        for (let index = 0; index < maxSell; index++) {
            const operand2Value = isNumeric(selSellParts[index * 4 + 2]) ? Number(selSellParts[index * 4 + 2]) : selSellParts[index * 4 + 2];
            const condition = {
                operand1: {value : selSellParts[index * 4] || ''},
                operator: {value : selSellParts[index * 4 + 1] || ''},
                operand2: {value : operand2Value, inputValue : operand2Value},
                conditional: {value : selSellParts[index * 4 + 3] === '$' ? 'None' : selSellParts[index * 4 + 3]},
                operand2Options: getOperand2Options(isNumeric(selSellParts[index * 4]) ? Number(selSellParts[index * 4]) : selSellParts[index * 4]),                
                enabled: {value : true},
                operatorEnabled: {value : true},
                operand2Enabled: {value : true},
                conditionalEnabled: {value : true},
                fromDb: {value : true}                
            };
            sellConditions.push(condition);
            dispatch(setCanDelete(true));
        }
        
        dispatch(setBuyConditions(buyConditions));
        dispatch(setSellConditions(sellConditions));
        dispatch(setLastConditionalSelectionBuy('None'));
        dispatch(setLastConditionalSelectionSell('None'));

        title = 'Buy';     
        updateSelectedItems(buyConditions, false);
        
        title = 'Sell'; 
        updateSelectedItems(sellConditions, false);     
    };

    const resetStrategies = () =>{
        dispatch(setLastConditionalSelectionBuy(''));
        dispatch(setBuyStrategy(''));  
        dispatch(setIsExpressionBuyCorrect(false));
        dispatch(setBuySelectedItems(''));
        dispatch(setBuyExpressionValidation(''));
        dispatch(setBuyConditions([
            { operand1: null, operator: null, operand2: null, conditional: null, enabled: true, operand2Options: [] }
        ]));

        dispatch(setLastConditionalSelectionSell(''));
        dispatch(setSellStrategy(''));  
        dispatch(setIsExpressionSellCorrect(false));
        dispatch(setSellSelectedItems(''));
        dispatch(setSellExpressionValidation(''));
        dispatch(setSellConditions([
            { operand1: null, operator: null, operand2: null, conditional: null, enabled: true, operand2Options: [] }
        ]));  
        
        dispatch(setCanDelete(false));
        dispatch(setSelectedStrategy(null));
        dispatch(setEditMode(false));
        dispatch(setSelectedRowIndex(null));
        setNoPremium(false);
        dispatch(setErrorMsg(null));
        setNote('');
    }

    const operand1Options = [
        { value: 'rsi', label: 'RSI', color:'#d287ff' },
        { value: '(rsi', label: '(RSI', color:'#d287ff' },
        { value: 'rsi)', label: 'RSI)', color:'#d287ff' },
        { value: 'rsi_ma', label: 'RSI_MA', color:'#f9c134' },
        { value: 'rsi_ma)', label: 'RSI_MA)', color:'#f9c134' },
        { value: '(rsi_ma', label: '(RSI_MA', color:'#f9c134' },
        { value: 'stoch_K', label: 'Stoch K', color:'#ff7f00' },
        { value: '(stoch_K', label: '(Stoch K', color:'#ff7f00' },
        { value: 'stoch_K)', label: 'Stoch K)', color:'#ff7f00' },
        { value: 'stoch_D', label: 'Stoch D', color:'#8834d8' },
        { value: 'stoch_D)', label: 'Stoch D)', color:'#8834d8' },
        { value: '(stoch_D', label: '(Stoch D', color:'#8834d8' },
        { value: 'macd', label: 'MACD', color:'#ff00b3' },
        { value: '(macd', label: '(MACD', color:'#ff00b3' },
        { value: 'macd)', label: 'MACD)', color:'#ff00b3' },
        { value: 'macd_signal', label: 'MACD Sig', color:'#8854d8' },
        { value: 'macd_signal)', label: 'MACD Sig)', color:'#8854d8' },
        { value: '(macd_signal', label: '(MACD Sig', color:'#8854d8' },
        { value: 'ema_1', label: 'Ema1', color:'#82ca9d' },
        { value: '(ema_1', label: '(Ema1', color:'#82ca9d' },
        { value: 'ema_1)', label: 'Ema1)', color:'#82ca9d' },
        { value: 'price', label: 'Price', color:'#26ff00' },
        { value: '(price', label: '(Price', color:'#26ff00' },
        { value: 'price)', label: 'Price)', color:'#26ff00' }   
    ];

    const operatorOptions = [
        { value: '>', label: '>' },
        { value: '=', label: '=' },
        { value: '<', label: '<' },
        { value: '>=', label: '>=' },
        { value: '<=', label: '<=' }
    ];

    const conditionalOptions = [
        { value: 'and', label: 'and' },
        { value: 'or', label: 'or' },
        { value: 'None', label: 'Finish' }
    ];

    const operand2OptionsMapping = {
        rsi: [
            { value: 0, label: 'Enter Number' },
            { value: 'rsi_ma', label: 'RSI_MA', color:'#f9c134' },
            { value: 'rsi_ma)', label: 'RSI_MA)', color:'#f9c134' },
            { value: '(rsi_ma', label: '(RSI_MA', color:'#f9c134' }
        ],
        rsi_ma: [
            { value: 0, label: 'Enter Number' }
        ],
        stoch_K: [
            { value: 'stoch_D', label: 'Stoch D', color:'#8834d8' },
            { value: 'stoch_D)', label: 'Stoch D)', color:'#8834d8' },
            { value: '(stoch_D', label: '(Stoch D', color:'#8834d8' },
            { value: 0, label: 'Enter Number' }
        ],
        stoch_D: [
            { value: 'stoch_K', label: 'Stoch K', color:'#ff7f00' },
            { value: '(stoch_K', label: '(Stoch K', color:'#ff7f00' },
            { value: 'stoch_K)', label: 'Stoch K)', color:'#ff7f00' },
            { value: 0, label: 'Enter Number' }
        ],
        macd: [
            { value: 'macd_signal', label: 'MACD Sig', color:'#8854d8' },
            { value: 'macd_signal)', label: 'MACD Sig)', color:'#8854d8' },
            { value: '(macd_signal', label: '(MACD Sig', color:'#8854d8' },
            { value: 0, label: 'Enter Number' }
        ],
        macd_signal: [
            { value: 'macd', label: 'MACD', color:'#ff00b3' },
            { value: '(macd', label: '(MACD', color:'#ff00b3' },
            { value: 'macd)', label: 'MACD)', color:'#ff00b3' },
            { value: 0, label: 'Enter Number' }
        ],
        ema_1: [
            { value: 'ema_2', label: 'Ema2', color:'#387908' },
            { value: 'ema_2)', label: 'Ema2)', color:'#387908' },
            { value: '(ema_2', label: '(Ema2', color:'#387908' }
        ],
        price: [
            { value: 'upper', label: 'Upper Band', color:'#ff0022' },
            { value: '(upper', label: '(Upper Band', color:'#ff0022' },
            { value: 'upper)', label: 'Upper Band)', color:'#ff0022' },
            { value: 'lower', label: 'Lower Band', color:'#ffca00' },
            { value: '(lower', label: '(Lower Band', color:'#ffca00' },
            { value: 'lower)', label: 'Lower Band)', color:'#ffca00' },
            { value: 'sma', label: 'SMA', color:'#8884a8' },
            { value: '(sma', label: '(SMA', color:'#8884a8' },
            { value: 'sma)', label: 'SMA)', color:'#8884a8' },
            { value: 'ema_1', label: 'Ema1', color:'#82ca9d' },
            { value: '(ema_1', label: '(Ema1', color:'#82ca9d' },
            { value: 'ema_1)', label: 'Ema1)', color:'#82ca9d' },
            { value: 'ema_2', label: 'Ema2', color:'#387908' },
            { value: 'ema_2)', label: 'Ema2)', color:'#387908' },
            { value: '(ema_2', label: '(Ema2', color:'#387908' },
            { value: 0, label: 'Enter Number' }
        ]
    };

    const refreshTokenIfNeeded = useCallback(async () => {
        if (isTokenExpired()) {        
          await handleLogin();
        }    
      },[]);

    useEffect(() => {
        
        // if(modalShow) return;
        if(modalShow && !justSaved) return;

        const get_all_strategies = async (wallet) => {
            try {
                await refreshTokenIfNeeded();
                                                                 
                const response = await fetch(`/api/get_all_strategies?wallet=${wallet}`, {
                    method: 'GET',
                    // credentials: 'include',
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken
                    }
                });
    
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error);
                }
    
                const result = await response.json();                
                const strategiesConverted = getBuySellStrategies(result);                
                setStrategies(strategiesConverted);
                
            } catch (err) {
                console.error('Error setting strategy:', err);
            }
        };

        if(walletId){
            get_all_strategies(walletId);
        }
        else{
            setStrategies([]);
        }

    }, [csrfToken, modalShow, justSaved, walletId, refreshTokenIfNeeded]);

    useEffect(() => {
        // Trigger blinking effect when editMode changes
        //if (editMode) {
            setBlink(true);
            const timer = setTimeout(() => setBlink(false), 1500);

            // Clean up the timer
            return () => clearTimeout(timer);
        //}
    }, [editMode]);

    useEffect(()=>{
        if(strategies.length === 20){
            setNotification('You’ve reached the limit of 20 strategies. To add a new one, consider replacing a lower-performing strategy if necessary or connect another wallet.');
        }
        else{
            setNotification('');
        }
    },[strategies.length])


    const del_strategy = async (wallet, strg_id) => {
        try {
            await refreshTokenIfNeeded();
            setActionStatus(false);
            setSpin(true);
                
            const response = await fetch(`/api/del_strategy`, {
                method: 'DELETE',
                // credentials: 'include',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken // Ensure csrfToken is correctly set
                },
                body: JSON.stringify({
                    wallet: wallet,
                    strategy_id: strg_id
                })
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error);
            }
    
            setActionStatus(true);
            setSpin(false);
    
            setTimeout(() => {
                setModalShow(false);
                setActionStatus(false); 
                resetStrategies();
            }, 1000);
    
        } catch (err) {
            console.error('Error deleting strategy:', err);
            setModalShow(false);
            setActionStatus(false);
            setSpin(false);
        }
    };
        
    const set_strategy = async (wallet, buy_strategy, sell_strategy, note) => {
        try {
            await refreshTokenIfNeeded();
            setJustSaved(false);
                      
            const response = await fetch(`/api/set_strategy`, {
                method: 'POST',
                // credentials: 'include',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify({
                    wallet: wallet, 
                    buy_strategy: buy_strategy,
                    sell_strategy: sell_strategy,
                    note: note
                })
            })

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error);
            }

            setJustSaved(true);

            console.log('Strategy created successfully');
        } catch (err) {
            console.error('Error setting strategy:', err);
            setJustSaved(false);
        }
    };

    const upd_strategy = async (wallet, buy_strategy, sell_strategy, strg_id, note) => {
        try {
            await refreshTokenIfNeeded();
            setJustSaved(false);
                      
            const response = await fetch(`/api/upd_strategy`, {
                method: 'POST',
                // credentials: 'include',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify({
                    wallet: wallet,
                    buy_strategy: buy_strategy,
                    sell_strategy: sell_strategy,
                    strategy_id: strg_id,
                    note: note
                })
            })

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error);
            }

            setJustSaved(true);

            console.log('Strategy updated successfully');
        } catch (err) {
            console.error('Error setting strategy:', err);
            setJustSaved(false);
        }
    };



    const getOperand2Options = (operand1) => {
        const baseValue = operand1.replace(/[()]/g, ''); // Removing unnecessary escape characters
        return operand2OptionsMapping[baseValue] || [];
    };

    const updateSelectedItems = (newConditions, noMessage=false) => {
        const items = newConditions
            .map(condition => {
                const { operand1, operator, operand2, conditional } = condition;                
                const parts = [];
                if (operand1 && operand1.value !== 'None') parts.push(`<span>${operand1.value}</span>`);
                if (operator && operator.value !== 'None') parts.push(`<span style="color:#216ba5;">${operator.value}</span>`);
                if (operand2 && operand2.value !== 'None') {
                    if (operand2.value === 0 && operand2.inputValue) {
                        parts.push(`<span>${operand2.inputValue}</span>`);
                    } else {
                        parts.push(`<span>${operand2.value}</span>`);
                    }
                }
                if (conditional && conditional.value !== 'None') parts.push(`<span style="color:yellow;">${conditional.value}</span>`);
                return parts.join(' ');
            })
            .join(' ');
           
        const sanitizedHtmlContent = DOMPurify.sanitize(items);

        const tempElement = document.createElement('div');
        tempElement.innerHTML = sanitizedHtmlContent;
        const textContent = tempElement.textContent || tempElement.innerText;

        const validationMsg = noMessage ? '' : validateLogicalExpression(textContent);
        

        if (title === 'Buy') {
            dispatch(setBuyExpressionValidation(validationMsg));
            dispatch(setBuyStrategy(textContent));
            dispatch(setIsExpressionBuyCorrect(validationMsg === 'AllGood'));
            dispatch(setBuySelectedItems(sanitizedHtmlContent));
        };
        if (title === 'Sell') {
            dispatch(setSellExpressionValidation(validationMsg));
            dispatch(setSellStrategy(textContent));
            dispatch(setIsExpressionSellCorrect(validationMsg === 'AllGood'));
            dispatch(setSellSelectedItems(sanitizedHtmlContent));
        };

        
    };

    const handleInputChange = (index, field, value) => { 

        let conditions = title === 'Buy' ? buyConditions : sellConditions;
           
        let newConditions = conditions.map((condition, idx) => (
            idx === index ? { ...condition } : condition
        ));
        let updatedCondition = { ...newConditions[index] };
    
        // Update the specific field in the cloned condition object
        updatedCondition[field] = value;
    
        let noMessage = false;
    
        if (field === 'operand1') {
            updatedCondition.operand2Options = getOperand2Options(value.value);
            updatedCondition.operator = null; // Reset operator
            updatedCondition.operand2 = null; // Reset operand2
            updatedCondition.operand2Enabled = false; // Disable operand2
            if (title === 'Buy') dispatch(setIsExpressionBuyCorrect(false));
            if (title === 'Sell') dispatch(setIsExpressionSellCorrect(false));
            noMessage = true;
        }
    
        if (field !== 'conditional' && value) {
            if (field === 'operand1' && !updatedCondition.operator) {
                updatedCondition.operatorEnabled = true;
            } else if (field === 'operator' && !updatedCondition.operand2) {
                updatedCondition.operand2Enabled = true;
            } else if (field === 'operand2' && !updatedCondition.conditional) {
                updatedCondition.conditionalEnabled = true;
            }
        }
    
        if (field === 'conditional') {
            if (title === 'Buy') dispatch(setLastConditionalSelectionBuy(value.value));
            if (title === 'Sell') dispatch(setLastConditionalSelectionSell(value.value));
            if (value && value.value !== 'None' && index === conditions.length - 1) {
                newConditions.push({ operand1: null, operator: null, operand2: null, conditional: null, enabled: true, operand2Options: [] });
            } else if (value && value.value === 'None') {
                newConditions = newConditions.slice(0, index + 1);
            }
        }
    
        // Update the newConditions array with the modified condition
        newConditions[index] = updatedCondition;
    
        if (title === 'Buy') dispatch(setBuyConditions(newConditions));
        if (title === 'Sell') dispatch(setSellConditions(newConditions));

        updateSelectedItems(newConditions, noMessage);
    };

    const isStrategyConcluded = title === 'Buy' ? buyConditions[buyConditions.length - 1]?.conditional?.value !== 'None' : 
                                                  sellConditions[sellConditions.length - 1]?.conditional?.value !== 'None';

    function validateLogicalExpression(expression) {
        // Define valid tokens
        const validTokens = ['rsi', 'stoch_D', 'stoch_K', '0', 'macd', 'price', 'upper', 'lower', 'sma', 'ema_1', 'ema_2'];
        const operators = ['=', '>', '<', '>=', '<=', '!='];
        const logicalOperators = ['and', 'or'];
        
        // Remove spaces for easier processing
        const expr = expression;
        // const expr = expression.replace(/\s+/g, '');

        const splt = expr.split(' ');

        for (let index = 0; index < splt.length; index++) {            
            if(index>0 && logicalOperators.includes(splt[index]) && operators.includes(splt[index-1])){
                return highlightOperationError(expression, splt[index]);
            }
            
        }
                
        // Check for balanced parentheses
        const stack = [];
        for (let i = 0; i < expr.length; i++) {
            if (expr[i] === '(') {
                stack.push('(');
            } else if (expr[i] === ')') {
                if (stack.length === 0 || stack.pop() !== '(') { 
                    console.log('---');                   
                    return highlightError(expression, i, 1);
                }                
            }           
        }

        if (stack.length !== 0) {
            console.log('000');
            return '<span style="color:#ff6000;">Unmatched opening parenthesis</span>';
        }
        
        // Tokenize the expression using a regular expression
        const tokens = expr.match(/([a-zA-Z_]\w*|[()>=<!]=?|[0-9]+|\band\b|\bor\b)/g);
        if (!tokens) {
        console.log('111');
        return 'Invalid expression';
        }
        // Check for single condition without logical operators
        if (tokens.length === 1) {
            const singleToken = tokens[0];
            if (validTokens.includes(singleToken) || !isNaN(singleToken)) {
                return 'AllGood';
            } else {
                console.log('222');
                return highlightError(expression, 0, singleToken.length);
            }
        }
    
        // Ensure the expression doesn't end with an operator or logical operator
        const lastToken = tokens[tokens.length - 1];
        if (operators.includes(lastToken) || logicalOperators.includes(lastToken.toLowerCase())) {
            return '<span style="color:#ff6000;">Expression ends with an operator or logical operator</span>';
        }
        
        return 'AllGood';
    }

function highlightError(expression, position, length) {
    const highlightedExpression = expression.substring(0, position) +
        '<span style="color:#ff6000;">' + expression.substr(position, length) + '</span>' +
        expression.substring(position + length);
    return highlightedExpression;
}

function highlightOperationError(expression, word) {
    const highlightedExpression = expression.replace(new RegExp(`(${word})`, 'gi'), '<span style="color:#ff6000;">$1</span>');
    return highlightedExpression;
}

const renderOperand2Control = (condition, index) => {    
    if (condition.operand2 && isNumeric(condition.operand2.value)) {
        return (
            <div className="numeric-input-container">
                <input
                    type="number"
                    className="numeric-input"
                    value={condition.operand2.inputValue || '0'}
                    onChange={(e) => handleInputChange(index, 'operand2', { value: 0, inputValue: e.target.value })}
                    placeholder="Enter numeric value"
                    style={{ height: '33px', width: '123px', background: 'transparent', border: '1px solid green', borderRadius: '4px', color: 'lightgray', textAlign: 'center' }}
                    disabled={!condition.operand2Enabled}
                    min="0.0" 
                    max="100.0"
                    step="0.1"
                />
                <button
                    className="back-button"
                    onClick={() => handleInputChange(index, 'operand2', null)}
                >
                    v
                </button>
            </div>
        );
    } else {
        return (
            <Select
                options={condition.operand2Options}
                value={condition.operand2}
                onChange={(value) => handleInputChange(index, 'operand2', value)}
                placeholder="Select or Enter Operand 2"
                styles={customStyles}
                classNamePrefix="react-select"
                isDisabled={!condition.operand2Enabled}
                components={{ 
                    SingleValue: (props) => <CustomSingleValue {...props} options={condition.operand2Options} />
                }}
            />
        );
    }
};

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        width: '100%',
        maxWidth: '300px',
        whiteSpace: 'nowrap',
        fontSize: '13pt',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        borderColor: state.selectProps.isDisabled ? 'gray' : !state.getValue().length ? 'orange' : 'green',
        boxShadow: state.isFocused ? 'none' : 'none', // Disable focus box shadow
        backgroundColor: 'transparent',
        '&:hover': {
            borderColor: state.isFocused ? 'blue' : 'gray',
        }
    }),
    menu: (provided, state) => ({
        ...provided,
        backgroundColor: '#131722',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#465b94' : '#1c202e',
        color: state.data.color,
        fontSize: '12pt',
        '&:hover': {
            backgroundColor: '#216ba5',
        },
    }),
    singleValue: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: "lightgray"
    }),
    placeholder: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
    }),    
    menuList: (provided, state) => ({
        ...provided,
        backgroundColor: '#131722'
    })  
};


const CustomSingleValue = ({ data, options }) => {
    const option = options.find(option => option.value === data.value);
    return (
        <div>
            {option ? option.label : 'No option'}
        </div>
    );
};

const getHtmlSelectSet = (condition, index) => {
    return (        
        <div className="condition-row" key={index}>
            <div className="column">
                <Select
                    options={operand1Options}                    
                    value={condition.operand1}                   
                    onChange={(value) => handleInputChange(index, 'operand1', value)}
                    placeholder="Select Operand 1"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    isDisabled={!condition.enabled}
                    components={{ 
                        SingleValue: (props) => <CustomSingleValue {...props} options={operand1Options} />
                    }}
                />
            </div>
            <div className="column">
                <Select
                    options={operatorOptions}
                    value={condition.operator}
                    onChange={(value) => handleInputChange(index, 'operator', value)}
                    placeholder="Select Operator"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    isDisabled={!condition.operatorEnabled}
                    components={{ 
                        SingleValue: (props) => <CustomSingleValue {...props} options={operatorOptions} />
                    }}
                />
            </div>
            <div className="column">
                {renderOperand2Control(condition, index)}
            </div>
            <div className="column">
                <Select
                    options={conditionalOptions}
                    value={condition.conditional}
                    onChange={(value) => handleInputChange(index, 'conditional', value)}
                    placeholder="Select Conditional"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    isDisabled={!condition.conditionalEnabled}
                    components={{ 
                        SingleValue: (props) => <CustomSingleValue {...props} options={conditionalOptions} />
                    }}
                />
            </div>
        </div>
    );
}

const getBuySellStrategies = (data) => {
    const strategies = {};
  
    data.forEach(item => {
      const strgId = item.strg_id;
      const expression = `${item.operand_1} ${item.operator} ${item.operand_2} ${item.optional_operator ? item.optional_operator : '$'}`.trim();
  
      if (!strategies[strgId]) {
        strategies[strgId] = { strgId: strgId, buy: [], sell: [], note:'' };
      }
  
      if (item.strg_buysell === 'buy') {
        strategies[strgId].buy.push(expression);
      } else if (item.strg_buysell === 'sell') {
        strategies[strgId].sell.push(expression);
      }
      strategies[strgId].note = item.note;
    });
  
    // Concatenate expressions for each strategy
    Object.keys(strategies).forEach(strgId => {
      strategies[strgId].buy = strategies[strgId].buy.join(' ');
      strategies[strgId].sell = strategies[strgId].sell.join(' ');      
    });
  
    return Object.values(strategies);  // Convert to an array of strategy objects
};

const cellStyle = {
    textAlign: 'center',
    width: '45%',    
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace:'nowrap'
  };

  const disabledStyle = {
    cursor: 'not-allowed',
    pointerEvents: 'none', // Disable all interactions
    opacity: 0.5, // Make it look disabled
  };

  const cannotSave = (!(lastConditionalSelectionBuy === 'None' && lastConditionalSelectionSell === 'None' && isExpressionBuyCorrect && isExpressionSellCorrect)) || (strategies.length === 20 && !editMode);

return (
    <>
    { title === 'Buy' &&
        <TextBaloon number="" textColor='#d2d2d2' text={<>Here, you can create strategies by combining available indicators. Colored elements will correspond to those in the ‘Indicators’ module, making it easier to identify and match them..<br/>The system will automatically handle EMA Crosses (Ema1 and Ema2) by replacing them with 4 different pairs.<br/>We recommend exploring the ‘Indicators’ module first to get familiar with each element before building your strategy. </>} color='#5358b7' />
    }
    {!isPremium && title === 'Buy' &&
       <>
        <div style={{ position: 'absolute', right: '8%' }}>
                <LimitedAdvise
                    width="80px"
                    height="20px"
                    message="Limited"
                    tooltipTitle="Why this page is limited?"
                    tooltipPhrases={[
                        "Saving, editing, and deleting strategies not available",
                        "Strategy simulation not available"
                    ]}
                    tooltipPosition="left" /* Options: top, down, left, right */
                    tooltipWidth='420px' />
            </div><br /><br /></>
    }
      <fieldset className="fieldset-rules" style={{ fontSize: '12px', borderColor: title === 'Buy' ? '#71baff' : '#8471ff' }}>
        <legend className={`legend`} style={{ color: title === 'Buy' ? '#71baff' : '#8471ff' }}>
            {title} Strategy <span className={`${blink ? 'blink' : ''}`}>{editMode ? 'Update' : 'Creation'}</span>
        </legend>
        <div className="selected-items" dangerouslySetInnerHTML={{ __html: title === 'Buy' ? buySelectedItems : sellSelectedItems }} />
        <div className="strategy-form-header">
          <div className="header-column">Operand 1</div>
          <div className="header-column">Operator</div>
          <div className="header-column">Operand 2</div>
          <div className="header-column">Conditional</div>
        </div>
        <div className="strategy-form-body">
          {title === 'Buy' && buyConditions.map((condition, index) => (
            getHtmlSelectSet(condition, index)
          ))}
  
          {title === 'Sell' && sellConditions.map((condition, index) => (
            getHtmlSelectSet(condition, index)
          ))}
  
          <div style={{ fontSize: '15pt', color: '#0ebd0e', padding: '10px', height: '20px' }}>
            {!isStrategyConcluded && (
              <div dangerouslySetInnerHTML={{ __html: title === 'Buy' ? (buyExpressionValidation === 'AllGood' ? `${title} strategy concluded` : buyExpressionValidation) : (sellExpressionValidation === 'AllGood' ? `${title} strategy concluded` : sellExpressionValidation) }} />
            )}
          </div>
        </div>
      </fieldset>

        
      {title === 'Sell' && (
        <>
        <br /> 

        <div style={{height:'25px'}}>
            {!cannotSave &&
                <div style={{display:'flex', gap:'10px'}}>
                    <span style={{whiteSpace:'nowrap', color:'#0094ff'}}>What is this strategy about?</span>
                    <input type='text' placeholder='Enter a short note' value={note} style={{width:'100%', color:'grey', backgroundColor:'transparent', border:'0', fontSize:'12pt'}} onChange={(e) => setNote(e.target.value)}></input>
                </div>  
            }
        </div>  
        <br />       

        <div className="button_wrapper">
            <div className="button_container button_create" onClick={() => resetStrategies()} >
                <i className="bi bi-plus-circle-fill" style={{ marginRight: '5px' }}></i>
                    Create
            </div>
            <div className="button_container button_save" style={ cannotSave ? disabledStyle : {}} onClick={() => saveStrategies()} >
                <i className="bi bi-save-fill" style={{ marginRight: '5px' }}></i>
                Save
            </div>
            <div className={`button_container button_duplicate ${!canDelete ? 'disabled' : ''}`} onClick={canDelete ? () => saveStrategies(true) : undefined} style={!canDelete ? disabledStyle : {}}>
                <i className="bi bi-copy" style={{ marginRight: '5px' }}></i>
                Duplicate
            </div>            

            <div className={`button_container button_delete ${!canDelete ? 'disabled' : ''}`} onClick={canDelete ? handleShow : undefined} style={!canDelete ? disabledStyle : {}}>
                <i className="bi bi-trash-fill" style={{ marginRight: '5px' }}></i>
                Delete
            </div>            
        </div><br/>

        {errorMsg &&                                                       
            <div className='error'>{errorMsg}</div>                           
        } 

        {noPremium &&
            <BecomePremiumInvite/>
        }

        <DecisionModal
            show={modalShow}
            onHide={handleClose}
            onConfirm={deleteStrategy}
            title={`You are deleting Strategy ${selectedStrategy}. This action will also delete any followed strategies`}
            spin={spin}
            actionConcluded={actionStatus}
        />

            {notification &&
                <div style={{borderRadius:'10px', color: '#7d00ff', padding: '10px', backgroundColor: 'gainsboro'}}>
                    {notification}
                </div>
            }

          <br />
  
          {strategies.length >= 0 && (
            <div className="tableContainer">
              <table className="table">
                <thead>
                  <tr style={{ backgroundColor: '#8cb753', color: '#3a4b00' }}>
                    <th>Strategy</th>                    
                    <th>Buy Strategy</th>
                    <th>Sell Strategy</th>                   
                    <th>Note</th>                   
                  </tr>
                </thead>
                <tbody>
                    {strategies.length > 0 && strategies.map((strategy, index) => (
                        <tr key={index} onClick={()=>handleSelection(strategy, index)} className={index === selectedRowIndex ? 'selectedRow' : ''}>
                        <td style={{width:'10%'}}>{strategy.strgId}</td>
                        <td style={cellStyle}>{strategy.buy.length > 25 ? strategy.buy.slice(0, 25) + ' ...' : strategy.buy.replace('$','')}</td>
                        <td style={cellStyle}>{strategy.sell.length > 25 ? strategy.sell.slice(0, 25) + ' ...' : strategy.sell.replace('$','')}</td>                        
                        <td style={cellStyle}>{strategy.note && strategy.note.length > 25 ? strategy.note.slice(0, 25) + ' ...' : strategy?.note}</td>
                        </tr>
                    ))}                    
                    {strategies.length === 0 && 
                        <tr>
                        <td colSpan={4} style={{width:'10%', fontSize:'15pt'}}>No data yet, your strategies will be listed here.</td>                        
                        </tr>
                    }
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default StrategyRuleSettings;

